/**
 * Generate the async status keypath
 * If requestKey is unspecified, the returned keyPath refers to all requests for the specified asyncId
 * @param {string} asyncId UUID used to group requests issued by a particular feature
 * @param {Array?} baseKeyPath Array of strings used to categorize requests
 * @param {string?} requestKey identifier used to classify the type of request
 * @param {string?} instanceId identifier used to store an instance of a request (for simultaneous requests of the same type)
 * @returns {Array} Array of strings [...baseKeyPath, asyncId {, requestKey {, instanceId}}]
 */
const getAsyncStatusKeyPath = (
	asyncId,
	baseKeyPath = null,
	requestKey = null,
	instanceId = null,
) => {
	const paths = baseKeyPath ? [...baseKeyPath, asyncId] : [asyncId];

	if (requestKey != null) {
		paths.push(requestKey);
		if (instanceId != null) {
			paths.push(instanceId);
		}
	}

	return paths;
};

export default getAsyncStatusKeyPath;
